<template>
  <div class="tipsPage">
    <!-- <div class="TipsTitle">{{tipsTitle}}</div> -->
    <div class="agrement">
      <iframe :src="tipsTitle" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import {
  isBeijing,
  registerUrl,
  sendCodeMessageUrl,
  userServiceDell,
  userPrivacyDell,
  userPayDell,
  userCertDell,
  userServiceDellHN,
  userCertDellHN,
  userRegistDell,
  userRegistDellHN,
  userPrivacyDellHN
} from "@/api/api";
export default {
  data() {
    return {};
  },
  props: ["type"],
  mounted() {
    // this.getTipsTitle()
  },

  computed: {
    tipsTitle() {
      let type = this.type;
      // alert(type)
      let url = "";
      switch (type) {
        case 1:
          if (isBeijing) {
            url = userServiceDell;
          } else {
            url = userServiceDellHN;
          }
          break;
        case 2:
          url = userPayDell;
          break;
        case 3:
          if (isBeijing) {
            url = userCertDell;
          } else {
            url = userCertDellHN;
          }
          break;
        case 4:
          url = isBeijing?userPrivacyDell:userPrivacyDellHN;
          break;
        case 5:
          if(isBeijing){
             url = userRegistDell;
          }else{
            url =userRegistDellHN
          }
          break;
      }
      return url;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.tipsPage {
  background-color: #fff;
  box-sizing: border-box;
  overflow: hidden;
}

.TipsTitle {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
}

.tips {
  font-size: 14px;
  color: #666;
}
.agrement {
  text-align: center;
}
.tipsItem {
  text-decoration: underline;
}
.footerItem {
  width: 100%;
  max-height: 10vh;
}
iframe {
  height: 650px;
  box-sizing: border-box;
  padding-left: 5px;
  padding-right: 5px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Tips.vue